module.exports = __webpack_public_path__ + "static/media/16_a_2.691328ee.png";